import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import indexMixin from "../mixins/index";
export default {
  name: 'res-cascader',
  mixins: [indexMixin],
  props: {
    options: {
      type: Array,
      default: () => []
    },
    props: {
      // 属性配置选项
      type: Object,
      default: () => {}
    }
  },
  watch: {
    options() {
      this.keyValue++; //只要监听到数据源发生变化 ，改变keyValue的值，达到重新渲染的效果
    },

    dataModel: {
      handler(val) {
        if (!val) return;
        this.$emit("input", val);
      },

      deep: true,
      immediate: true
    },

    value(val) {
      this.dataModel = val;
    }

  },
  computed: {
    valueToLabel() {
      let arr = [];
      if (!this.dataModel) return;
      this.flatten(this.options);
      this.dataModel.map(val => {
        let str = '';
        val.forEach(el => {
          str += `/${this.arrDic[el].label}`;
        });
        arr.push(str.substring(1));
      });
      return arr.join("、") || '';
    }

  },

  data() {
    return {
      keyValue: 0,
      dataModel: this.value,
      arrDic: {}
    };
  },

  methods: {
    flatten(arr) {
      let {
        value,
        children
      } = this.props;
      console.log(value, '   ', children);
      return arr.reduce((pre, cur) => {
        this.arrDic[cur[value]] = cur;
        Array.isArray(cur[children]) ? this.flatten(cur[children]) : cur;
      }, []);
    }

  }
};